export const hasMoreThanOneItem = <T>(array: ArrayLike<T>): boolean => array.length > 1
